import { toggleNotifications } from "../pwa/notifications";
import { DEVICE_KEYS, removeDevice } from "./device-store";
export async function clearDeviceData():Promise<boolean>{
 let ok=true;try{await toggleNotifications(false)}catch{ok=false;}
 for(const key of DEVICE_KEYS)if(!removeDevice(key))ok=false;
 for(const name of ["localStorage","sessionStorage"] as const)try{const store=globalThis[name];for(const key of Object.keys(store))if(key.startsWith("arabom:"))store.removeItem(key)}catch{ok=false;}
 try{if(typeof indexedDB!=="undefined")indexedDB.deleteDatabase("arabom-device");if(typeof caches!=="undefined")for(const key of await caches.keys())if(key.startsWith("arabom-public-"))await caches.delete(key)}catch{ok=false;}
 dispatchEvent(new Event("arabom:device-cleared"));return ok;
}
